import {useDebugValue} from 'react';

import {useSearchFormContext} from '../../../hooks/useSearchFormContext';

import {showDestinationlessError} from '../../../utils/experiments';

import {
    showDestinationInputFieldError,
} from '../../../utils/destination';

function useComponent() {
    const {
        abacusStore,
        mediaSettings,
        formOptions,
        formSettings,
        destinationOptions,
        latestDestinationValues,
        systemOptions,
    } = useSearchFormContext();

    const showDestinationErrorMessage = showDestinationlessError({shouldLogExperiment: false}, abacusStore, formSettings, systemOptions, false) && showDestinationInputFieldError(mediaSettings, formOptions, formSettings, destinationOptions, latestDestinationValues, abacusStore, systemOptions);

    const result = {showDestinationErrorMessage};

    useDebugValue(result);

    return result;
}

export {useComponent};